import { API_ORIGIN } from "@/lib/apiConfig";

export const PANEL_PATH = import.meta.env.VITE_ADMIN_PANEL_PATH || "/g7-painel-x9k";

/** URL absoluta do painel na API (funciona com frontend em dominio separado). */
export const PANEL_API_BASE = `${API_ORIGIN}${PANEL_PATH}`;
